/* Product page AND homepage buy box (any [data-ds-pdp] root): pack radios (name="id", so the form is right even before this runs), CTA price, gallery (+ lazy demo video),
   AJAX add to cart with line-item properties, double-add guard. */
(function () {
  var root = document.querySelector('[data-ds-pdp]');
  if (!root) return;
  var DS = (window.DS = window.DS || {});
  var cfgEl = root.parentNode.querySelector('[data-ds-pdp-config]');
  var cfg = {};
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var fmt = function (c) { return DS.formatMoney ? DS.formatMoney(c) : String(c / 100); };
  var t = DS.t || {};
  var form = root.querySelector('[data-ds-form]');
  var addBtn = root.querySelector('[data-ds-add]');
  var addLabel = root.querySelector('[data-ds-add-label]');
  var variants = cfg.variants || [];
  var byId = {};
  variants.forEach(function (v) { byId[String(v.id)] = v; });

  function idField() { return form && (form.querySelector('input[name="id"]:checked') || form.querySelector('input[type=hidden][name="id"]')); }
  function current() { var f = idField(); return (f && byId[String(f.value)]) || variants[0]; }

  function escapeHtml(s) { return String(s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function ctaHtml(v, label) {
    if (!v || !v.available) return t.soldOut || 'Agotado';
    return escapeHtml(label || cfg.atc) + ' <span class="ds-btn__sep">·</span> <span class="ds-btn__price">' + fmt(v.price) + '</span>';
  }

  // gallery
  var track = root.querySelector('[data-ds-track]');
  var dotsWrap = root.querySelector('[data-ds-dots]');
  var variantMedia = {};
  variants.forEach(function (x) { if (x.media) variantMedia[String(x.media)] = true; });
  function visibleSlides() { return track ? Array.prototype.filter.call(track.children, function (el) { return !el.hidden; }) : []; }
  function syncGallery() {
    if (!track) return;
    var vis = visibleSlides();
    var i = Math.min(vis.length - 1, Math.max(0, Math.round(track.scrollLeft / Math.max(1, track.clientWidth))));
    if (dotsWrap) {
      if (dotsWrap.children.length !== vis.length) { dotsWrap.innerHTML = vis.map(function () { return '<span></span>'; }).join(''); }
      Array.prototype.forEach.call(dotsWrap.children, function (d, k) { d.classList.toggle('is-active', k === i); });
    }
  }
  function showVariantMedia(v, jump) {
    if (!track) return;
    var cur = v && v.media ? String(v.media) : null;
    var first = track.children[0] ? track.children[0].getAttribute('data-media-id') : null;
    // colour photos (data-color): only the selected colour's, when that colour has any; shared photos always
    var col = (v && v.color) || '';
    var colHas = col && track.querySelector('[data-color="' + col.replace(/"/g, '') + '"]');
    Array.prototype.forEach.call(track.children, function (el) {
      var id = el.getAttribute('data-media-id'), mc = el.getAttribute('data-color');
      var hide = id !== first && !!variantMedia[id] && id !== cur;
      if (mc && colHas && mc !== col) hide = true;
      el.hidden = hide;
    });
    var slide = cur ? track.querySelector('[data-media-id="' + cur + '"]') : null;
    if ((!slide || slide.hidden) && colHas && jump === 'color') slide = track.querySelector('[data-color="' + col.replace(/"/g, '') + '"]:not([hidden])');
    if (slide && jump === 'color') { loadDeferred(); track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' }); syncGallery(); return; }
    if (jump === 'color') { track.scrollTo({ left: 0, behavior: 'smooth' }); }
    if (slide && jump && cur !== first) { loadDeferred(); track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' }); }
    syncGallery();
  }

  function update(fromUser) {
    var v = current();
    if (!v) return;
    if (addBtn && !busy) { addBtn.disabled = !v.available; if (addLabel) addLabel.innerHTML = ctaHtml(v); }
    document.querySelectorAll('[data-ds-live-price]').forEach(function (el) { el.textContent = fmt(v.price); });
    document.querySelectorAll('[data-ds-live-pack]').forEach(function (el) { el.textContent = v.title; });
    document.querySelectorAll('[data-ds-live-color]').forEach(function (el) { el.textContent = v.color || ''; el.hidden = !v.color; });
    document.querySelectorAll('[data-ds-live-cta]').forEach(function (el) { el.innerHTML = ctaHtml(v, el.getAttribute('data-label')); });
    var f = idField(), c = form && form.querySelector('[data-ds-prop-contents]');
    if (c && f && f.hasAttribute('data-contents')) c.value = f.getAttribute('data-contents');
    var pc = form && form.querySelector('[data-ds-prop-color]');
    if (pc && v.color) pc.value = v.color;
    showVariantMedia(v, fromUser);
    if (fromUser && cfg.url !== false && window.history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(history.state, '', u); }
    document.dispatchEvent(new CustomEvent('ds:variant', { detail: v }));
  }

  root.addEventListener('change', function (e) {
    if (e.target.matches('[data-ds-packs] input[name="id"]')) update(true);
    else if (e.target.name === 'ds-color') update('color');
  });

  // deferred gallery images (keep LCP to the first image only)
  var deferredDone = false;
  function loadDeferred() {
    if (deferredDone) return; deferredDone = true;
    root.querySelectorAll('img[data-ds-defer]').forEach(function (img) { img.srcset = img.getAttribute('data-srcset'); img.removeAttribute('data-ds-defer'); });
  }
  window.addEventListener('load', function () { setTimeout(loadDeferred, 1200); });
  ['pointerdown', 'touchstart', 'keydown'].forEach(function (ev) {
    root.addEventListener(ev, function (e) { if (e.target.closest && e.target.closest('[data-ds-gallery]')) loadDeferred(); }, { passive: true });
  });
  if (track) track.addEventListener('scroll', function () { loadDeferred(); syncGallery(); }, { passive: true });

  // demo video: starts after the page has loaded, muted; sound toggle
  var video = root.querySelector('[data-ds-video]');
  if (video) {
    var sound = root.querySelector('[data-ds-sound]');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var startVideo = function () {
      if (video.src) return;
      video.src = video.getAttribute('data-src');
      video.addEventListener('playing', function () { video.style.zIndex = 1; if (sound) sound.hidden = false; }, { once: true });
      var p = video.play(); if (p && p.catch) p.catch(function () {});
    };
    if (!reduce) window.addEventListener('load', function () { setTimeout(startVideo, 400); });
    video.addEventListener('click', function () { if (!video.src) startVideo(); else if (video.paused) video.play(); else video.pause(); });
    if (sound) sound.addEventListener('click', function () {
      video.muted = !video.muted;
      sound.setAttribute('aria-label', video.muted ? 'Activar sonido' : 'Silenciar');
      sound.innerHTML = video.muted
        ? '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 9h4l5-4v14l-5-4H4z"/><path d="M17 9l4 6M21 9l-4 6"/></svg>'
        : '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 9h4l5-4v14l-5-4H4z"/><path d="M17 9a4 4 0 0 1 0 6"/></svg>';
    });
  }

  if (DS.fillEta) DS.fillEta();

  // line-item properties, read from the form (Contenido / Entrega estimada / Prueba)
  function properties() {
    var props = {}, has = false;
    if (!form) return null;
    form.querySelectorAll('input[name^="properties["]').forEach(function (i) {
      var k = i.name.slice(11, -1);
      if (i.value) { props[k] = i.value; has = true; }
    });
    return has ? props : null;
  }

  // add to cart (AJAX -> drawer). Without JS the form posts normally (the checked radio is the id).
  var busy = false;
  function add() {
    var v = current();
    if (!v || !v.available || !addBtn) return Promise.resolve();
    if (busy) return Promise.resolve();
    busy = true;
    addBtn.disabled = true;
    if (addLabel) addLabel.textContent = t.adding || '…';
    var done = function () { busy = false; addBtn.disabled = false; update(false); };
    if (!DS.add) { form.submit(); return Promise.resolve(); }
    var item = { id: v.id, quantity: 1 }, props = properties();
    if (props) item.properties = props;
    return DS.add([item], { price: v.price }).then(done, function (err) {
      done();
      // only fall back to a normal post if the add itself failed (never add twice)
      if (!err || err.stage !== 'render') form.submit();
    });
  }
  if (form) form.addEventListener('submit', function (e) { e.preventDefault(); add(); });

  function scrollToPacks() {
    var target = root.querySelector('[data-ds-packs]') || addBtn;
    if (!target) return;
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    target.classList.add('ds-pulse'); setTimeout(function () { target.classList.remove('ds-pulse'); }, 1500);
  }

  // CTAs elsewhere on the page: data-ds-buy="add" adds the selected pack, "scroll" jumps to the selector
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-ds-buy]');
    if (!b) return;
    e.preventDefault();
    if (b.getAttribute('data-ds-buy') === 'add') { add(); } else { scrollToPacks(); }
  });

  DS.pdp = { current: current, add: add, scrollToPacks: scrollToPacks, root: root };
  update(false);
})();
